import { Component, OnInit } from "@angular/core";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { Subscription } from "rxjs";
import { ModalEditarEstadoComponent } from "src/app/components/core/layouts/modal-editar-estado/modal-editar-estado.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DetalleSolicitudService } from "./detalle-solicitud.service";
import { ModalComentariosComponent } from "src/app/components/core/layouts/modal-comentarios/modal-comentarios.component";
import { Router } from "@angular/router";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { DetalleEstablecimientoService } from "../opciones/establecimiento/establecimiento.service";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { MenuService } from "src/app/components/menu/menu.service";
import { EstablecimientoComercioService } from "../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { ModalValidarRenovacionComponent } from '../../../../layouts/modal-validar-renovacion/modal-validar-renovacion.component';
import { ModalValidarSubcategoriaComponent } from "src/app/components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component";
import { SubcategoriaService } from '../../administrador/configuracion/subcategoria/subcategoria.service';
import { EstadosRnt } from '../../../../../../shared/enumeraciones/estados-rnt.enum';

@Component({
  selector: "app-detalle-solicitud",
  templateUrl: "./detalle-solicitud.component.html",
  styleUrls: ["./detalle-solicitud.component.scss"],
})
export class DetalleSolicitudComponent implements OnInit {
  estados: Array<any>;
  comentarios: Array<any>;
  suscripcion: Subscription;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  descripcion: any;
  // tipo de solicitud
  inscripcion = TipoSolicitud.Inscripcion;
  renovacion = TipoSolicitud.Renovacion;
  suspencion = TipoSolicitud.Suspension;
  cancelacion = TipoSolicitud.Cancelacion;
  actualizacion = TipoSolicitud.Actualizacion;
  reactivacion = TipoSolicitud.Reactivacion;
  estado_suspendido_por_no_renovar = EstadosRnt.SuspendidoPorNoRenovar;
  reactivacionAnticipada = TipoSolicitud.ReactivacionAnticipada;
  inmueble = TipoRnt.Inmuebles;
  guia = TipoRnt.Guia;
  establecimiento = TipoRnt.Establecimiento;
  tipo_funcionario = RolesUsuario.Funcionario;
  // informacion establecimiento
  informacionEstablecimiento: any;
  tipo_prestador_guia = TipoPrestador.Guia;
  tipo_prestador = RolesUsuario.Prestador;
  userLogin: boolean;
  constructor(
    private dataSharedService: DataSharedService,
    private modalService: NgbModal,
    private detalleServices: DetalleSolicitudService,
    private router: Router,
    public authService: AuthService,
    private detalleEstablecimientoService: DetalleEstablecimientoService,
    public ayudaService: AyudasService,
    private menuService: MenuService,
    private establecimientoComercioService: EstablecimientoComercioService,
    private subcategoriaService: SubcategoriaService
  ) {
    this.suscripcion = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });
    this.informacionEstablecimiento = {};
    this.userLogin = authService.isToken();
  }

  ngOnInit() {
    if (!this.datoSolicitudSharedModel.data) {
      this.router.navigate([
        this.menuService.getRoles().horizontal[0].ruta_url,
      ]);
      return;
    }

    this.detalleEstablecimientoService
      .getDetalleEstablecimiento(this.datoSolicitudSharedModel.data)
      .subscribe((res) => {
        if (res.result) {
          this.informacionEstablecimiento = res.data;
          this.validarRenovacionSegunTipoSolicitud();
          this.validarSubCategoria();
          this.establecimientoComercioService
            .getParametro({
              parametro_id: "EXONERACION_FONTUR_MUNICIPIO",
              agrupacion: "VALIDACIONES",
              auxiliar: "1",
            })
            .subscribe((resultado) => {
              if (resultado.result) {
                this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur = resultado.data.startsWith(
                  res.data.municipio_id
                );
              }
            });
        }
      });
  }
  validarRenovacionSegunTipoSolicitud():void{

    if(this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Renovacion){
       this.validarRenovacion();
     }
  }
  validarSubCategoria():void{
    if(this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Inscripcion ||
      this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Actualizacion ||
      this.datoSolicitudSharedModel.data.tipo_solicitud_id === TipoSolicitud.Renovacion){
       this.validarSubCategoriaCIIU();
     }
  }
  validarSubCategoriaCIIU():void{
    let prestador_id:number= this.informacionEstablecimiento.prestador_id;
    let sub_categoria_id: number= this.informacionEstablecimiento.sub_categoria_id;
    let tipo_rnt_id = this.datoSolicitudSharedModel.tipo_rnt;
    if(prestador_id != null &&
        sub_categoria_id != null &&
        tipo_rnt_id != null){
          this.subcategoriaService
          .validarActividadesEconomicasCiiu(prestador_id,sub_categoria_id,tipo_rnt_id)
          .subscribe(response =>{
              if(!response.data){
                this.detalleServices
                    .getParametro({
                      parametro_id: "ADVERTENCIA_ACTIVIDAD_ECONOMICA_NO_CORRESPONDE_SUBCATEGORIA_FUNCIONARIO",
                      agrupacion: "VALIDACIONES",
                      auxiliar: "1",
                    })
                    .subscribe((resultado2) => {
                      if (resultado2.result) {
                        const modalAceptarTerminos = this.modalService.open(
                          ModalValidarSubcategoriaComponent,
                          { centered: true, backdrop: "static", size: "md" }
                        );
                        modalAceptarTerminos.componentInstance.mensaje =resultado2.data;

                      }
                    });
              }
          })
    }
  }
  validarRenovacion():void{
    let prestador_id :number= this.informacionEstablecimiento.prestador_id;
    let establecimiento_id:number= this.informacionEstablecimiento.establecimiento_id;
    if(prestador_id != null && establecimiento_id != null){
          this.detalleEstablecimientoService
          .validarRenovacion(establecimiento_id,prestador_id)
          .subscribe(response =>{
            if (!response.result) {
              //SI EL ESTABLECIMIENTO ESTA VENCIDO
              if( Number(response.control.code) === 1){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO_FUNCIONARIO'
                },true);
              }
              //SI EL PRESTADOR ESTA VENCIDO
              if( Number(response.control.code) === 2){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR_FUNCIONARIO'
                },true);
              }
              //SI EL PRESTADOR Y ESTABLECIMIENTO ESTAN VENCIDOS
              if( Number(response.control.code) === 3){
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_DEBE_ACTUALIZAR_DATOS_RUES_PRESTADOR_FUNCIONARIO'
                },false);
                this.getParam({
                  agrupacion: 'VALIDACIONES',
                  auxiliar:1,
                  parametro_id: 'ADVERTENCIA_DEBE_ACTUALIZAR_DATOS_RUES_ESTABLECIMIENTO_FUNCIONARIO'
                },true);
              }
            }
          });
    }
  }
  getParam({parametro_id,agrupacion,auxiliar},hasAction: boolean): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
            },
            (error) => {
            }
          );
  }
  onOpenModalStatus() {
    const modalRef = this.modalService.open(ModalEditarEstadoComponent, {
      centered: true,
      size: "xl",
      backdropClass: "light-blue-backdrop",

    });
    modalRef.componentInstance.estados = this.estados;
    modalRef.componentInstance.descripcion = this.descripcion;
    modalRef.result.then((resultado) => {
      const modalRef_2 = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        { centered: true }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message = `¿Está seguro de cambiar el estado de la solicitud a ${resultado.estado_descripcion}?`;
      modalRef_2.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef_2.result.then(() => {
        resultado.observaciones = resultado.observaciones.replace(
          new RegExp("\r?\n", "g"),
          "<br />"
        );
        if(resultado.motivo_devolucion_id != ''){
          resultado.motivo_devolucion_id = resultado.motivo_devolucion_id.join();
        }
        this.datoSolicitudSharedModel.data.descripcion_estado_solicitud =
          resultado.estado_descripcion;
        this.detalleServices
          .update({ ...resultado, ...this.datoSolicitudSharedModel.data })
          .subscribe((res) => {
            if (res.result) {
              this.router.navigate(["solicitud-registro-funcionario"]);
            }
          });
      });
    });
  }

  onOpenModalComments() {
    const modalRef = this.modalService.open(ModalComentariosComponent, {
      centered: true,
      size: "xl",
      backdropClass: "light-blue-backdrop"
    });
    modalRef.componentInstance.comentarios = this.comentarios;
    modalRef.result.then((resultado) => {});
  }

  // onComments() {
  // 	this.detalleServices.getComentarios(this.datoSolicitudSharedModel.data).subscribe(res => {
  // 		this.comentarios = res.data;
  // 		this.onOpenModalComments();
  // 	});
  // }

  onEstados() {
    this.detalleServices
      .getEstados({
        tipo_solicitud_id: this.datoSolicitudSharedModel.data.tipo_solicitud_id,
        solicitud_id: this.datoSolicitudSharedModel.data.solicitud_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.estados = resultado.data;
          this.detalleServices
            .getDecripciones(this.informacionEstablecimiento.sub_categoria_id)
            .subscribe((res) => {
              if (res.result) {
                this.descripcion = res.data.descripcion_requisitos;
                this.onOpenModalStatus();
              }
            });
        }
      });
  }
}
